// extracted by mini-css-extract-plugin
export default {"rightColumn":"Dashboard_rightColumn__-nJ0T"};